var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"support-context-summary"},_vm._l((_vm.rows),function(item){return _c('div',{key:item[0],staticClass:"support-context-summary__row",class:{ 'support-context-summary__row--highlight': item[2] }},[_c('span',[_vm._v(_vm._s(item[0]))]),_c('strong',[_vm._v(_vm._s(item[1]))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }